import { gql } from '@apollo/client';
import Fragments from './fragments';

export const DOCUMENT_SYNC_STATES_QUERY = gql`
  query documentSyncStates {
    documentSyncStates {
      ...documentSyncState
    }
  }
  ${Fragments.documentSyncState}
`;

export const DOCUMENT_STATE_X_TYPE_QUERY = gql`
  query documentStatesXType {
    documentStatesXType {
      ...documentStateXType
    }
  }
  ${Fragments.documentStateXType}
`;

export const DICTIONARY_SYNC_TYPE_QUERY = gql`
  query dictionarySyncType {
    dictionarySyncType {
      ...dictionarySyncType
    }
  }
  ${Fragments.dictionarySyncType}
`;
